var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mb-base",attrs:{"title":"Statistiques"}},[_c('div',{staticClass:"mt-5"},[_c('h5',[_vm._v(_vm._s(_vm.$t('letters_monthly_trend_table')))]),_c('chartjs-component-bar-chart5',{attrs:{"height":150}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }